<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h3>Deadlines</h3>
        <b-row>
          <b-col v-for="(d, i) in deadlines" :key="d.date">
            <b-card
              :class="{ muted: d.endDate != selectedDeadline.endDate }"
              class="deadlines"
            >
              <div
                class="d-flex justify-content-between align-items-center mb-5"
              >
                <h4 class="m-0">#{{ i + 1 }}</h4>
                <p class="m-0">
                  {{ d.endDate | moment("D MMM YYYY") }}
                </p>
              </div>

              <div
                class=" d-flex justify-content-between align-items-center mb-2"
              >
                <div class="d-flex align-items-center">
                  <span class="kt-list-timeline__badge bg-danger"></span>
                  <span class="text-danger ml-3">Below</span>
                </div>
                <span class="text-danger"> &lt; {{ d.points.lvl1 }}</span>
              </div>
              <div
                class=" kt-list-timeline__item d-flex justify-content-between align-items-center mb-2"
              >
                <div class="d-flex align-items-center">
                  <span class="kt-list-timeline__badge bg-warning"></span>
                  <span class="text-warning ml-3">Lvl 1</span>
                </div>
                <span class="text-warning"> &gt;= {{ d.points.lvl1 }}</span>
              </div>
              <div
                class="kt-list-timeline__item d-flex justify-content-between align-items-center mb-0"
              >
                <div class="d-flex align-items-center">
                  <span class="kt-list-timeline__badge bg-success"></span>
                  <span class="text-success ml-3">Lvl 2</span>
                </div>
                <span class="text-success"> >= {{ d.points.lvl2 }}</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="filter">
        <b-select :options="groups" v-model="filterGroup"></b-select>
      </b-col>
    </b-row>

    <b-row v-if="!loading">
      <b-col md="7" class="users">
        <b-card
          no-body
          class="card-custom mb-1"
          v-for="(u, index) in students"
          :key="u._id"
          :class="{ 'bg-dark text-light': u._id == me._id }"
        >
          <b-card-body class="px-5 py-1">
            <div class="d-grid ">
              <div
                class="position font-size-h1 font-weight-bolder text-right pr-3"
              >
                <span class="font-size-h4"
                  ><b-icon-trophy v-if="index < 3"></b-icon-trophy
                ></span>
                {{ index + 1 }}
              </div>
              <div class="info">
                <div class="d-flex align-items-center">
                  <div class="avatar">
                    <img :src="getUserPhoto(u.avatar)" class="avatar" alt="" />
                  </div>
                  <div class="text">
                    <span class="font-weight-bolder font-size-h5 mb-0 username">
                      {{ u.firstName }} {{ u.lastName }}
                      <small>{{ u.userName }}</small>
                    </span>

                    <div class="text-muted font-size-lg mt-0" v-if="u.team">
                      {{ getTeam(u.team) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <!-- <span class="points">
                <span v-for="p of u.points.profiles" :key="p._id" class="mr-3">
                  <span class="badge badge-light p-4 px-8">
                    <IconProfile
                      :profileId="p.profile"
                      class="mr-4"
                    ></IconProfile>
                    {{ p.points }}</span
                  >
                </span>
              </span> -->
                <profiles-points
                  :points="u.points.profiles"
                  :empty="true"
                ></profiles-points>
              </div>
              <div
                class="font-weight-bolder  font-size-h3 text-right"
                v-if="u.points"
                :class="colorPoints(u.points.total)"
              >
                {{ u.points.total.toFixed(0) }}
              </div>
            </div>
            <!-- <div
              v-if="
                selectedDeadline.points.level1 &&
                  u.points.total < selectedDeadline.points.level1
              "
              class="progress"
              style="height:auto"
            >
              <div
                class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
                role="progressbar"
                :style="{
                  width:
                    (u.points.total / selectedDeadline.points.level1) * 100 +
                    '%',
                }"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
                style="height: 5px"
              ></div>
            </div> -->
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="5" class="teams" v-if="teams">
        <b-card
          v-for="(t, index) in teams"
          :key="t._id"
          no-body
          :class="{ 'bg-dark text-light': t._id == myTeam._id }"
        >
          <b-card-body class="px-5 py-1">
            <div class="d-grid align-items-center">
              <div
                class="position font-size-h1 font-weight-bolder text-right pr-3"
              >
                <span class="font-size-h4"
                  ><b-icon-trophy v-if="index < 3"></b-icon-trophy
                ></span>
                {{ index + 1 }}
              </div>
              <div class="info d-flex align-items-center">
                <div class="avatar text-center">
                  <img :src="getTeamPhoto(t.logo)" alt="" class="avatar" />
                </div>
                <div class=" font-size-h4 font-weight-bolder">
                  {{ t.name }}
                </div>
              </div>

              <div class="d-flex flex-column members">
                <div class="d-flex flex-wrap justify-content-center">
                  <div
                    class="symbol symbol-40 symbol-light-danger mr-3 my-3 "
                    v-for="u in t.users"
                    :key="u._id"
                  >
                    <div class="symbol-label">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <img
                              :src="getUserPhoto(u.avatar)"
                              width="40px"
                              alt=""
                          /></span>
                        </template>
                        <span>{{ u.firstName }} {{ u.lastName }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <span class="font-weight-bolder font-size-h4">
                  {{ puntsTeam(t.users) }}
                </span>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import ProfilesPoints from "../layout/dashboard/ProfilesPoints.vue";

export default {
  name: "rankin",
  components: { ProfilesPoints },
  data() {
    return {
      groups: ["A", "B", "All Together"],
      hover: false,
      userShow: true,
      teamShow: false,
      teampoints: [],
      filterGroup: "All Together",
      // deadlines: [
      //   {
      //     date: "2023-10-24T00:00:00.000Z",
      //     points: {
      //       level1: 2000,
      //       level2: 3000,
      //     },
      //   },
      //   {
      //     date: "2023-11-28T00:00:00.000Z",
      //     points: {
      //       level1: 3500,
      //       level2: 4000,
      //     },
      //   },
      //   {
      //     date: "2023-12-19T00:00:00.000Z",
      //     points: {
      //       level1: 5000,
      //       level2: 7000,
      //     },
      //   },
      //   {
      //     date: "2024-01-16T00:00:00.000Z",
      //     points: {
      //       level1: 6000,
      //       level2: 8000,
      //     },
      //   },
      //   {
      //     date: "2024-02-20T00:00:00.000Z",
      //     points: {
      //       level1: 9000,
      //       level2: 11000,
      //     },
      //   },
      //   {
      //     date: "2024-04-23T00:00:00.000Z",
      //     points: {
      //       level1: 12500,
      //       level2: 15000,
      //     },
      //   },
      // ],
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Ranking" }]);
    this.filterGroup = this.me.group;
    //console.log(this.filterGroup);
  },
  computed: {
    deadlines() {
      return this.$store.getters.getDeadlines;
    },
    roleStudent() {
      return this.$store.getters.getRoles.find((r) => r.name === "student")
        ?._id;
    },
    selectedDeadline() {
      let now = new Date();
      let deadline = this.deadlines.find(
        (d) =>
          new Date(d.endDate).setDate(new Date(d.endDate).getDate() + 7) > now
      );
      console.log(deadline);
      return deadline;
    },
    isDead() {
      let now = new Date();
      let deadline = this.deadlines.findIndex(
        (d) =>
          new Date(d.endDate).setDate(new Date(d.endDate).getDate() + 7) > now
      );
      console.log(deadline);
      return this.deadlines[deadline - 1];
    },
    teams() {
      let tm = this.$store.getters.getTeams.filter((t) =>
        this.filterGroup != "All Together"
          ? t.group == this.filterGroup
          : t.group != 1
      );
      return tm.sort(
        (a, b) =>
          this.puntsTeam(b.users) / b.users.length -
          this.puntsTeam(a.users) / a.users.length
      );
    },
    students() {
      let st = this.$store.getters.getUsers.filter((u) => {
        let valid =
          u.roles.includes(this.roleStudent) &&
          (this.filterGroup != "All Together"
            ? u.group == this.filterGroup
            : u.group != 1);
        return valid;
      });
      return st.sort((a, b) => b.points.total - a.points.total);
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    loading() {
      return this.$store.state.loading;
    },
    me() {
      return this.$store.getters.getMyUser;
    },
    myTeam() {
      return this.$store.getters.getMyTeam || { _id: 0 };
    },
  },
  methods: {
    colorPoints(points) {
      if (points < this.selectedDeadline.points.lvl0) {
        return "text-danger";
      } else if (points < this.selectedDeadline.points.lvl1) {
        return "";
      } else if (points < this.selectedDeadline.points.lvl2) {
        return "text-warning";
      } else {
        return "text-success";
      }
    },
    puntsTeam(u) {
      let points = 0;
      for (let x = 0; x < u.length; x++) {
        points += u[x].points.total;
      }
      return points;
    },
    getTeam(team) {
      let t = this.teams?.find((t) => t._id === team);
      return t?.name;
    },
    getUserPhoto(avatar) {
      return avatar
        ? process.env.VUE_APP_API_URL_UPLOADS + avatar
        : "/media/svg/avatars/001-boy.svg";
    },
    getTeamPhoto(img) {
      return img
        ? process.env.VUE_APP_API_URL_UPLOADS + img
        : "/media/svg/logos/javascript.svg";
    },
  },
};
</script>

<style lang="scss" scoped>
/* .progress{
  background-color: #EBEDF3;
} */
.kt-list-timeline__badge {
  width: 5px;
  height: 5px;
  border-radius: 100%;
}
.users {
  .d-grid {
    display: grid;
    grid-template-columns: repeat(1, 50px 1fr 1fr 70px);
    align-items: center;
  }
}
.muted {
  opacity: 0.3;
}
.teams {
  .d-grid {
    display: grid;
    grid-template-columns: repeat(1, 50px 1fr 1fr 70px);
    align-items: center;
  }
}
.deadlines {
  color: #888888;
}
.position {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.btn.btn-outline-primary {
  color: #6cc5a5;
  background-color: transparent;
  border-color: #6cc5a5;
}

.btn.btn-outline-primary:hover:not(.btn-text):not(:disabled):not(.disabled),
.btn.btn-outline-primary:focus:not(.btn-text),
.btn.btn-outline-primary.focus:not(.btn-text) {
  background-color: #6cc5a5;
  border-color: #6cc5a5;
}

.btn.btn-outline-primary:not(:disabled):not(.disabled):active:not(.btn-text),
.btn.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn.btn-outline-primary.dropdown-toggle,
.show .btn.btn-outline-primary.btn-dropdown {
  background-color: #6cc5a5;
  border-color: #6cc5a5;
}

.profilename-responsive {
  display: none;
}

img.ranking {
  margin-right: 10px;
}

.team-title h2 {
  margin-top: 25px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.team-title a {
  color: black;
}

.logo img.ranking {
  width: auto;
  max-height: 50px;
  max-width: 100%;
  height: auto;
}

@media (min-width: 700px) {
  .profilename-responsive {
    display: inline;
  }
}

.logo {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo img,
.avatar img {
  max-height: 100%;
  max-width: 100%;
}

.avatar {
  overflow: hidden;
  width: 40px;
  height: 40px;
  margin-right: 30px;
  border-radius: 4px;
}

.avatar img {
  width: 70px;
  height: auto;
}

.members .symbol.symbol-light-danger .symbol-label {
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.members img {
  border-radius: 3px;
}
</style>
